<template>
    <Select
        filterable
        v-bind="$attrs"
        :model-value="options.length ? modelValue : undefined"
        :options="options"
        label-field="name"
        :max-height-option-container="maxSelectHeight"
        value-field="id"
        @input="
            $emit('update:modelValue', $event);
            $emit('input', $event);
        "
    >
        <template #no-options>
            <div
                class="text-blue-600 px-3 py-2 text-center"
                v-text="$t('selectCountry.countryNotFound')"
            ></div>
        </template>
    </Select>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import { orderBy } from 'lodash-es';
import type { LocalizedCountry } from '@/api/backend/resources/CountryResource';

/**
 * This component provides country selection using our select component.
 */
export default defineComponent({
    name: 'SelectCountry',
    inheritAttrs: false,
    props: {
        /**
         * v-model country id
         */
        modelValue: {
            type: Number,
            default: null,
        },
        /**
         * customizable height for the select in pix
         */
        maxSelectHeight: {
            type: Number,
            default: null,
        },
        /**
         * in case we only want certain countries in the list
         */
        customList: {
            type: Array as PropType<LocalizedCountry[]>,
            default: null,
        },
    },
    emits: ['update:modelValue', 'input'],
    computed: {
        options(): LocalizedCountry[] {
            if (this.customList) return this.customList;

            return orderBy(this.$store.getters['platform/countries'] as LocalizedCountry[], ['name'], ['asc']);
        },
    },
    created() {
        this.$store.dispatch('platform/useCountries');
    },
});
</script>
